import { createApiSaga } from '../../../sagaGenerator';
import { apiDelete, apiGet, apiPatch } from '../../../../middleware/api';
import {
  TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_REQUEST,
  TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_SUCCESS,
  TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_FAILURE,
  TSUNAMI_EVENT_DATA_VALIDITY_REQUEST,
  TSUNAMI_EVENT_DATA_VALIDITY_SUCCESS,
  TSUNAMI_EVENT_DATA_VALIDITY_FAILURE,
  TSUNAMI_EVENT_DATA_REGION_REQUEST,
  TSUNAMI_EVENT_DATA_REGION_SUCCESS,
  TSUNAMI_EVENT_DATA_REGION_FAILURE,
  TSUNAMI_EVENT_DATA_RUNUP_REGION_REQUEST,
  TSUNAMI_EVENT_DATA_RUNUP_REGION_SUCCESS,
  TSUNAMI_EVENT_DATA_RUNUP_REGION_FAILURE,
  TSUNAMI_EVENT_DATA_CAUSE_REQUEST,
  TSUNAMI_EVENT_DATA_CAUSE_SUCCESS,
  TSUNAMI_EVENT_DATA_CAUSE_FAILURE,
  TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST,
  TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_SUCCESS,
  TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_FAILURE,
  TSUNAMI_EVENT_DATA_BULK_EDIT_REQUEST,
  TSUNAMI_EVENT_DATA_BULK_EDIT_SUCCESS,
  TSUNAMI_EVENT_DATA_BULK_EDIT_FAILURE,
} from './tsunamiEventDataReducer';


const bulkEditTsunamiSaga = createApiSaga({
  apiFunction: apiPatch,
  generateApiConfig: action => ({ endpoint: '/tsunamis/events', ...action }),
  requestType: TSUNAMI_EVENT_DATA_BULK_EDIT_REQUEST,
  successType: TSUNAMI_EVENT_DATA_BULK_EDIT_SUCCESS,
  failureType: TSUNAMI_EVENT_DATA_BULK_EDIT_FAILURE,
  successMessage: 'Saved',
});

const deleteTsunamiEventSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}`, ...action }),
  requestType: TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_REQUEST,
  successType: TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_SUCCESS,
  failureType: TSUNAMI_EVENT_DATA_DELETE_TSUNAMI_EVENT_FAILURE,
  successMessage: 'Deleted',
});

const getValiditySaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/validity', ...action }),
  requestType: TSUNAMI_EVENT_DATA_VALIDITY_REQUEST,
  successType: TSUNAMI_EVENT_DATA_VALIDITY_SUCCESS,
  failureType: TSUNAMI_EVENT_DATA_VALIDITY_FAILURE,
});

const getCauseSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/causes', ...action }),
  requestType: TSUNAMI_EVENT_DATA_CAUSE_REQUEST,
  successType: TSUNAMI_EVENT_DATA_CAUSE_SUCCESS,
  failureType: TSUNAMI_EVENT_DATA_CAUSE_FAILURE,
});

const getRunupMeasureTypesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/measurement-types', ...action }),
  requestType: TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST,
  successType: TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_SUCCESS,
  failureType: TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_FAILURE,
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/regions', ...action }),
  requestType: TSUNAMI_EVENT_DATA_REGION_REQUEST,
  successType: TSUNAMI_EVENT_DATA_REGION_SUCCESS,
  failureType: TSUNAMI_EVENT_DATA_REGION_FAILURE,
});

const getRunupRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/regions', ...action }),
  requestType: TSUNAMI_EVENT_DATA_RUNUP_REGION_REQUEST,
  successType: TSUNAMI_EVENT_DATA_RUNUP_REGION_SUCCESS,
  failureType: TSUNAMI_EVENT_DATA_RUNUP_REGION_FAILURE,
});

export const tsunamiEventDataSagas = [
  bulkEditTsunamiSaga,
  deleteTsunamiEventSaga,
  getValiditySaga,
  getCauseSaga,
  getRunupMeasureTypesSaga,
  getRegionsSaga,
  getRunupRegionsSaga,
];
